// import firebase from "firebase";
import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getFunctions } from 'firebase/functions';
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyA4e_4HpUpBWz9A5PamiiZLOcNHqa-P70g",
  authDomain: "cpg-app-3718d.firebaseapp.com",
  databaseURL: "https://cpg-app-3718d-default-rtdb.firebaseio.com",
  projectId: "cpg-app-3718d",
  storageBucket: "cpg-app-3718d.appspot.com",
  messagingSenderId: "1077261013973",
  appId: "1:1077261013973:web:4a43124216b49e78a4e35c",
  measurementId: "G-YZ9PVTQL0M",
};
const app =initializeApp(firebaseConfig);

// utils
const db = getFirestore();
const rdb=getDatabase(app)
const auth =getAuth();
const storage = getStorage();
const functions = getFunctions(app);

export { db,rdb, auth, storage ,functions};
